module.exports = __webpack_public_path__ + "img/o-swimming-pool.8fad539f.jpg";